// src/pages/admin/AdminDashboard.tsx
import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { useThemePalette } from '../../hooks/useThemePalette';

interface Stats {
  totalBooks: number;
  liveBooks:  number;
  draftBooks: number;
  totalUnits: number;
}

export default function AdminDashboard() {
  const C = useThemePalette();
  const [stats,   setStats]   = useState<Stats | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDocs(collection(db, 'books'))
      .then(snap => {
        let liveBooks = 0, draftBooks = 0, totalUnits = 0;
        snap.forEach(d => {
          const data = d.data();
          if (data.status === 'live') liveBooks++; else draftBooks++;
          totalUnits += data.units ?? 0;
        });
        setStats({ totalBooks: snap.size, liveBooks, draftBooks, totalUnits });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const cards = [
    { label: 'Total Books', value: stats?.totalBooks ?? 0, color: C.accent   },
    { label: 'Live',        value: stats?.liveBooks  ?? 0, color: C.success  },
    { label: 'Draft',       value: stats?.draftBooks ?? 0, color: C.premium  },
    { label: 'Total Units', value: stats?.totalUnits ?? 0, color: C.accent2  },
  ];

  return (
    <div style={{ padding: '32px' }}>
      <div style={{ fontSize: '1.1rem', fontWeight: 800, color: C.text, marginBottom: '8px' }}>Platform Overview</div>
      <div style={{ fontSize: '0.8rem', color: C.muted, marginBottom: '28px' }}>Live statistics from Firestore</div>

      {loading ? (
        <div style={{ color: C.muted, fontSize: '0.85rem' }}>Loading...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '16px' }}>
          {cards.map(card => (
            <div key={card.label} style={{
              background: C.card, border: `1px solid ${C.border}`,
              borderRadius: '16px', padding: '28px 22px',
            }}>
              <div style={{ fontSize: '2.4rem', fontWeight: 900, color: card.color, lineHeight: 1 }}>{card.value}</div>
              <div style={{ fontSize: '0.78rem', color: C.muted, marginTop: '10px', fontWeight: 600 }}>{card.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
